
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"100","cy":"100","r":"100"}}),_c('path',{attrs:{"d":"M151.63 106c-5.52-10.62-7.65-11.47-7.01-15.3.64-3.4 4.25-4.04 4.46-8.29.21-2.97-.85-6.8-1.27-8.07-2.55-9.14-3.82-14.23-6.37-18.48-7.86-13.17-29.74-20.82-50.99-18.27-8.29 1.06-31.65 3.82-41.64 23.79-9.77 19.12 1.27 40.79 2.55 43.13 3.61 6.59 5.74 7.01 8.71 12.53 5.95 12.75 1.91 28.26-5.52 42.91-.42.64 0 1.49.85 1.49 16.78.21 33.78.21 50.56.42.85 0 1.49-.42 1.91-1.06l8.71-13.6c.42-.85 1.27-1.06 2.12-.85l18.06 5.1c1.06.21 2.12 0 2.97-.64 3.19-2.55 4.04-4.67 4.25-6.37.21-2.76-1.7-4.46-.42-6.59.85-1.49 1.7-1.91 2.97-2.55 1.49-.85 2.55-1.7 2.76-2.34 0-.21-.21-.85-.85-1.27l-1.49-1.27 2.76-1.91c.64-.21.85-.42 1.06-.85.64-1.7-3.19-4.04-2.97-6.37.21-2.55 5.74-2.76 7.22-6.37.64-1.28-.84-3.83-3.39-8.92zM99.15 84.33c-1.91 1.06-4.25.64-5.52-1.27-.21-.21-.21-.42-.42-.85l-4.25.42-4.25 9.77-10.41-4.46-.42-3.82c.42 0 .85-.21 1.06-.42 1.91-1.06 2.55-3.61 1.27-5.52-1.06-1.91-3.61-2.55-5.52-1.27s-2.55 3.61-1.27 5.52l.21.21-2.76 2.34-10.62-4.67 4.67-10.62 4.04-.21c0 .42.21 1.06.64 1.49 1.06 1.91 3.61 2.55 5.52 1.27 1.91-1.27 2.55-3.61 1.27-5.52-1.06-1.91-3.61-2.55-5.52-1.27 0 0-.21 0-.21.21l-2.55-3.19 4.67-10.62 9.77 4.25 2.97-2.55c-.64-1.7 0-3.61 1.7-4.67 1.91-1.06 4.25-.64 5.52 1.27 1.06 1.91.64 4.25-1.27 5.52-.21 0-.21.21-.42.21l.21 4.04 9.77 4.25-4.25 9.77 2.55 3.4c1.7-.85 4.04-.21 5.1 1.49 1.06 1.88.63 4.22-1.28 5.5z","fill":"#fff"}})])
          )
        }
      }
    